export enum LicenceActionTypes {
  GET_LICENCES_REQUEST = "GET_LICENCES_REQUEST",
  GET_LICENCES_SUCCESS = "GET_LICENCES_SUCCESS",
  GET_LICENCES_ERROR = "GET_LICENCES_ERROR",
}
